const clientBase = {
    systemTheme: 'light',
	fileUrl: 'http://file.pynfc.com',
};

// dev
export const dev = {
    env: 'dev',
    client: {
        clientUrl: 'http://192.168.3.41:8805',
        serverUrl: 'http://192.168.3.41:8093',
        ...clientBase
    }
};
// prod
export const prod = {
    env: 'prod',
    client: {
        clientUrl: 'https://mo.pynfc.com',
        serverUrl: 'https://api.pynfc.com',
        ...clientBase
    }
};
